export const routes = {
  main: "/",
  homePage: "/home",
  account: "/account",
  signup: "/signup",
  signin: "/signin",
  recoverPassword: "/recover-password",
  resetPassword: "/reset-password",
  aboutUs: "/about-us", // Add this route if it doesn't exist
  article: "/article",
  renewpage: "/renewpage",
  support: "/support",
  dashboard: "/dashboard",
  adminDashboard: "/admin-dashboard",
  profile: "/profile",
  quotation: "/quotation",
  verify: "/verify",
  lead: "/lead",
  payment: "/payment",
  paymentsuccess: "/payment-success",
  requestDetail: "/request-detail/:id",
};
